// Removes personalization add-ons (wristbands, sticker packs) whose device is no longer in the cart.
// Add-ons carry a "For" line item property naming their device ("SpotBand" or "EasySnap"), set on
// the product page and by the cart's "Personalize your SpotTot" section.
(function () {
  const DEVICE_HANDLES = {
    SpotBand: ['spotwatch-wrist-spottot', 'spotwatch-wrist-spottot-add-one-more'],
    EasySnap: ['easysnap-clip-spottot', 'easysnap-clip-spottot-add-one-more'],
  };
  let syncing = false;

  async function sync() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await (await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })).json();
      const handlesInCart = new Set(cart.items.map((item) => item.handle));
      const updates = {};
      cart.items.forEach((item) => {
        const device = item.properties && item.properties.For;
        if (!DEVICE_HANDLES[device]) return;
        const deviceInCart = DEVICE_HANDLES[device].some((handle) => handlesInCart.has(handle));
        if (!deviceInCart) updates[item.key] = 0;
      });
      if (Object.keys(updates).length === 0) return;
      await fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      window.location.reload();
    } catch (error) {
      console.error('cart-addon-sync', error);
    } finally {
      syncing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
    }
  });
})();
